import { makeStyles } from '@mui/styles'

export default makeStyles((theme: any) => ({
    PatientIdentityStatusContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '.5rem',
    },
    PatientIdentityStatusParent: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '.5rem 0',
    },
    PatientIdentityStatus: {
        borderRadius: 100,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '.7rem 1.4rem',
        gap: '2rem',
        height: 'fit-content',
    },
    PatientIdentityStatusDot: {
        padding: 0,
        width: '14px',
        height: '14px',
    },
    PatientIdentityStatusLabel: {
        flex: 1,
        color: '#ffffff',
        textAlign: 'center',
        fontSize: '.8rem',
        [theme.breakpoints.up('md')]: {
            fontSize: '1rem',
        },
    },
    PatientIdentityStatusEditionButton: {
        flex: 0,
        background: '#ffffff',
        '&:hover': {
            background: '#fafafa',
        },
        '& svg': {
            width: '1rem',
            height: '1rem',
        },
    },
    PatientIdentityStatusUnlockButton: {
        boxShadow: 'none !important',
        padding: '.75rem',
        width: '2.89rem',
        height: '2.89rem',
        minHeight: 'unset',
        '& svg': {
            width: '100%',
            height: '100%',
        },
        '& .PatientIdentityStatusUnlockButton-svg-container': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            transition: 'transform .12s cubic-bezier(0,-1.8,1,1.8)',
        },
        '&:hover': {
            '& .PatientIdentityStatusUnlockButton-svg-container': {
                transform: 'scale(1.3)',
            },
        },
    },
}))
